<script>
export default {
  name: "darkBtn",
  props: {
    link: {
      type: String,
      required: false,
      default: null,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  }
};
</script>

<template>
  <router-link v-if="link" :to="link" class="darkBtn">
    <slot></slot>
  </router-link>
  <a v-else class="darkBtn">
    <slot></slot>
  </a>
</template>

<style scoped>
.darkBtn {
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
  width: 207px;
  height: 50px;
  border-radius: 15px;
  background: #1a1a1a;
  color: #fff;
  text-align: center;
  font-family: Aeroport;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 19px;
  height: 60px;
}

.darkBtn.active {
  background: #70F;
}


</style>